import { render } from "./S118068.vue?vue&type=template&id=009bc9b7"
const script = {}
script.render = render

export default script